import "bootstrap/js/src/tab";
import AOS from "aos";
import "aos/dist/aos.css";

import "./topbar";
import "./cookie-consent";
import "../styles/index.scss";

AOS.init();
